import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`;

export const MainAction = styled.button`
  border: none;
  background-color: #ff7417;
  color: #fff;
  padding: 0.5rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 0.25rem;
  transition: all 0.1s;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    cursor: pointer;
    transform: scale(1.05);
  }

  &:disabled {
    opacity: 0.6;
  }
`;

export const CancelAction = styled.button`
  border: none;
  outline: 1px solid #ff7417;
  color: #ff7417;
  background-color: transparent;
  padding: 0.5rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 0.25rem;
  transition: all 0.1s;

  &:hover {
    cursor: pointer;
    transform: scale(1.05);
  }
`;

export const ErrorMessage = styled.p`
  margin: 0;
  background-color: rgba(255, 0, 0, 0.2);
  border: 1px solid #ff0000;
  color: #ff0000;
  padding: 1.25rem;
  border-radius: 0.25rem;
  font-size: 0.9rem;
  font-weight: 500;
`;